const remove_markdown = (text: string): string => {
  return text.replace(/[\{]+([^\|\｜]+)([\|\｜](.+?\}+))+/g, '$1')
}

export default remove_markdown
